// Coarse maritime waypoint graph so the "Play His Life" cinematic routes
// ship legs along sea lanes instead of cutting across land.
// Nodes are open-water waypoints; edges follow real shipping routes.

const NODES = {
  northsea_s: [52.3, 2.6],
  northsea_c: [54.5, 1.2],
  northsea_n: [57.6, 0.6],
  forth: [56.15, -2.2],
  skagerrak: [57.9, 9.0],
  kattegat: [56.6, 11.7],
  oresund: [55.85, 12.75],
  baltic_s: [54.6, 11.8],
  dover: [51.0, 1.35],
  channel_w: [49.8, -3.6],
  st_george: [51.4, -6.3],
  irish_sea: [53.6, -5.0],
  north_channel: [55.25, -6.1],
  biscay: [45.5, -6.5],
  finisterre: [43.4, -9.9],
  portugal_c: [38.6, -10.2],
  gibraltar_s: [35.95, -5.7],
  alboran: [36.1, -3.0],
  balearic: [38.6, 3.5],
  gulf_lion: [42.0, 4.5],
  ligurian: [43.2, 8.4],
  sardinia_s: [38.1, 8.7],
  tyrrhenian: [39.9, 12.4],
  messina: [38.1, 15.7],
  malta_c: [36.0, 14.4],
  ionian: [36.3, 18.8],
  aegean_s: [36.2, 24.8],
  aegean_n: [39.2, 25.5],
  marmara: [40.4, 27.7],
  crete_e: [34.3, 27.5],
  port_said: [31.8, 32.2],
  suez_s: [29.2, 32.9],
  red_sea: [19.5, 38.8],
  bab_mandeb: [12.5, 43.5],
  gulf_aden: [12.8, 47.8],
  guardafui: [12.1, 51.9],
  somalia_e: [4.0, 50.0],
  east_africa: [-2.0, 42.8],
  io_w: [-1.5, 49.5],
  arabian_sea: [11.0, 60.0],
  laccadive: [7.0, 74.5],
  dondra: [5.5, 80.7],
  lanka_e: [7.5, 82.3],
  bengal: [11.5, 82.0],
  malacca_n: [6.2, 96.0],
  malacca: [3.6, 99.8],
  singapore_c: [1.2, 103.9],
  scs_s: [4.5, 107.5],
  scs_n: [15.0, 113.5],
  luzon_w: [15.8, 119.0],
  hk_s: [21.5, 114.3],
  azores: [38.0, -28.0],
  madeira_c: [32.9, -17.2],
  canary_c: [28.6, -14.8],
  atl_eq: [2.0, -26.0],
  carib_e: [15.5, -60.0],
  pr_n: [19.3, -65.8],
  carib_c: [15.0, -70.5],
  windward: [19.9, -74.2],
  bahamas_c: [24.3, -77.4],
  florida_s: [24.6, -80.2],
  panama_n: [9.7, -79.8],
  panama_s: [8.3, -79.4],
  ecuador_w: [-1.0, -82.5],
  peru_w: [-12.5, -78.5],
  chile_w: [-33.0, -73.5],
  cape_horn: [-57.2, -66.5],
  argentina_e: [-37.5, -55.0],
  brazil_s: [-27.5, -46.5],
  brazil_e: [-22.5, -40.5],
  brazil_ne: [-7.0, -33.0],
};

const EDGES = [
  ["northsea_s", "dover"],
  ["northsea_s", "northsea_c"],
  ["northsea_c", "northsea_n"],
  ["northsea_n", "forth"],
  ["northsea_n", "skagerrak"],
  ["skagerrak", "kattegat"],
  ["kattegat", "oresund"],
  ["oresund", "baltic_s"],
  ["dover", "channel_w"],
  ["channel_w", "biscay"],
  ["channel_w", "st_george"],
  ["st_george", "irish_sea"],
  ["irish_sea", "north_channel"],
  ["biscay", "finisterre"],
  ["finisterre", "portugal_c"],
  ["finisterre", "azores"],
  ["portugal_c", "gibraltar_s"],
  ["portugal_c", "madeira_c"],
  ["gibraltar_s", "alboran"],
  ["gibraltar_s", "canary_c"],
  ["alboran", "balearic"],
  ["balearic", "gulf_lion"],
  ["gulf_lion", "ligurian"],
  ["ligurian", "tyrrhenian"],
  ["balearic", "sardinia_s"],
  ["sardinia_s", "tyrrhenian"],
  ["sardinia_s", "malta_c"],
  ["tyrrhenian", "messina"],
  ["messina", "malta_c"],
  ["messina", "ionian"],
  ["malta_c", "ionian"],
  ["ionian", "aegean_s"],
  ["ionian", "crete_e"],
  ["aegean_s", "aegean_n"],
  ["aegean_n", "marmara"],
  ["aegean_s", "crete_e"],
  ["crete_e", "port_said"],
  ["port_said", "suez_s"],
  ["suez_s", "red_sea"],
  ["red_sea", "bab_mandeb"],
  ["bab_mandeb", "gulf_aden"],
  ["gulf_aden", "guardafui"],
  ["guardafui", "arabian_sea"],
  ["guardafui", "somalia_e"],
  ["somalia_e", "east_africa"],
  ["east_africa", "io_w"],
  ["io_w", "arabian_sea"],
  ["io_w", "laccadive"],
  ["arabian_sea", "laccadive"],
  ["laccadive", "dondra"],
  ["dondra", "lanka_e"],
  ["lanka_e", "bengal"],
  ["dondra", "malacca_n"],
  ["bengal", "malacca_n"],
  ["malacca_n", "malacca"],
  ["malacca", "singapore_c"],
  ["singapore_c", "scs_s"],
  ["scs_s", "scs_n"],
  ["scs_n", "luzon_w"],
  ["scs_n", "hk_s"],
  ["azores", "carib_e"],
  ["madeira_c", "canary_c"],
  ["canary_c", "atl_eq"],
  ["atl_eq", "brazil_ne"],
  ["brazil_ne", "brazil_e"],
  ["brazil_e", "brazil_s"],
  ["brazil_s", "argentina_e"],
  ["argentina_e", "cape_horn"],
  ["cape_horn", "chile_w"],
  ["chile_w", "peru_w"],
  ["peru_w", "ecuador_w"],
  ["ecuador_w", "panama_s"],
  ["panama_s", "panama_n"],
  ["panama_n", "carib_c"],
  ["carib_e", "carib_c"],
  ["carib_e", "pr_n"],
  ["carib_e", "brazil_ne"],
  ["pr_n", "bahamas_c"],
  ["carib_c", "windward"],
  ["windward", "bahamas_c"],
  ["bahamas_c", "florida_s"],
  ["florida_s", "azores"],
];

const hav = (a, b) => {
  const R = 6371;
  const dLat = ((b[0] - a[0]) * Math.PI) / 180;
  const dLng = ((b[1] - a[1]) * Math.PI) / 180;
  const s =
    Math.sin(dLat / 2) ** 2 +
    Math.cos((a[0] * Math.PI) / 180) *
      Math.cos((b[0] * Math.PI) / 180) *
      Math.sin(dLng / 2) ** 2;
  return 2 * R * Math.asin(Math.sqrt(s));
};

const ADJ = {};
for (const [x, y] of EDGES) {
  const d = hav(NODES[x], NODES[y]);
  (ADJ[x] = ADJ[x] || []).push([y, d]);
  (ADJ[y] = ADJ[y] || []).push([x, d]);
}

function nearest(pt) {
  let best = null;
  let bd = Infinity;
  for (const id in NODES) {
    const d = hav(pt, NODES[id]);
    if (d < bd) {
      bd = d;
      best = id;
    }
  }
  return best;
}

function dijkstra(src, dst) {
  const dist = { [src]: 0 };
  const prev = {};
  const visited = new Set();
  for (;;) {
    let u = null;
    let best = Infinity;
    for (const k in dist) {
      if (!visited.has(k) && dist[k] < best) {
        best = dist[k];
        u = k;
      }
    }
    if (u === null) return null;
    if (u === dst) break;
    visited.add(u);
    for (const [v, w] of ADJ[u] || []) {
      const nd = dist[u] + w;
      if (nd < (dist[v] ?? Infinity)) {
        dist[v] = nd;
        prev[v] = u;
      }
    }
  }
  const path = [dst];
  while (path[0] !== src) path.unshift(prev[path[0]]);
  return path;
}

// Returns an array of [lat, lng] points from a to b following sea lanes.
export function seaRoute(a, b) {
  const A = [a.lat, a.lng];
  const B = [b.lat, b.lng];
  if (hav(A, B) < 250) return [A, B];
  const na = nearest(A);
  const nb = nearest(B);
  if (na === nb) return [A, B];
  let ids = dijkstra(na, nb);
  if (!ids) return [A, B];
  while (ids.length > 1 && hav(A, NODES[ids[1]]) < hav(NODES[ids[0]], NODES[ids[1]])) {
    ids = ids.slice(1);
  }
  while (
    ids.length > 1 &&
    hav(B, NODES[ids[ids.length - 2]]) < hav(NODES[ids[ids.length - 1]], NODES[ids[ids.length - 2]])
  ) {
    ids = ids.slice(0, -1);
  }
  return [A, ...ids.map((id) => NODES[id]), B];
}
